var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_14488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_14488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05 13C5.76667 13 5.52083 12.8959 5.3125 12.6875C5.10417 12.4792 5 12.2334 5 11.95C5 11.6667 5.10417 11.4209 5.3125 11.2125C5.52083 11.0042 5.76667 10.9 6.05 10.9H17.95C18.2333 10.9 18.4792 11.0042 18.6875 11.2125C18.8958 11.4209 19 11.6667 19 11.95C19 12.2334 18.8958 12.4792 18.6875 12.6875C18.4792 12.8959 18.2333 13 17.95 13H6.05Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.46510a4f6a1c82f6b492e6f8b570b14b.svg";
export { ForwardRef as ReactComponent };